import { useQuery } from "react-query";
import { ResponseVehicle } from "services/motorpoint/shortlist";
import { vehicleService } from "services/vehicle/vehicleService";

export const QUERY_KEY = "recentlyviewed:vehicles";

const useGetVehicles = (stockBookNumbers: number[] | undefined) => {
    const getVehicles = async (sbns: number[] | undefined): Promise<ResponseVehicle[]> => {
        try {
            const uniqueSbnArray = [...new Set(sbns)];

            const { getMinifiedVehicleByStockNumber } = vehicleService();

            const promiseArray = uniqueSbnArray.map((sbn) => getMinifiedVehicleByStockNumber(sbn));

            const results = await Promise.allSettled(promiseArray);

            return results
                .filter((entry) => entry.status === "fulfilled")
                .map((entry) => (entry as unknown as PromiseFulfilledResult<any>).value);
        } catch (_error) {
            return [];
        }
    };

    const queryData = useQuery({
        queryKey: QUERY_KEY,
        queryFn: () => getVehicles(stockBookNumbers),
        retry: 3,
        retryDelay: (attemptIndex, error) => {
            return Math.pow(2, attemptIndex) * 200;
        },
        refetchOnWindowFocus: false,
        enabled: !!stockBookNumbers?.length,
    });

    return { vehicles: queryData?.data || [] };
};

export default useGetVehicles;
